import PropTypes from 'prop-types';
import React from 'react';
import SummaryNumber from 'components/VisualizationStrategies/SummaryNumber';
import HorizontalCard from '../shared/HorizontalCard';
import phoenixRender, {SIZES, PARTS} from './phoenixRender';

const HEIGHT = 56;
const WIDTH = 96;

const ChartHorizontal = ({card, chartRender}) => (
  <HorizontalCard
    visualization={
      chartRender && chartRender.image ? (
        <img
          src={`data:image/png;base64,${chartRender.image.data}`}
          style={{width: WIDTH, height: HEIGHT}}
        />
      ) : null
    }
  >
    <div>{card.title}</div>
    {chartRender && chartRender.summary ? (
      <SummaryNumber
        number={chartRender.summary.value}
        label={chartRender.summary.label}
        size={SummaryNumber.SIZES.MICRO}
      />
    ) : null}
  </HorizontalCard>
);

ChartHorizontal.propTypes = {
  card: PropTypes.object.isRequired,
};

export default phoenixRender(() => ({
  width: WIDTH,
  height: HEIGHT,
  size: `${SIZES.MEDIUM}:${WIDTH}:${HEIGHT}`,
  parts: [PARTS.SUMMARY, PARTS.IMAGE],
}))(ChartHorizontal);
